import React from "react"
import renderElement from "../../utils/renderElement"

import "./article.scss"

const SingleImageVideo = ({ article, isBlog }) => {
  return (
    <section className={"single-full-imagevideo image-article"}>
      <div className={isBlog ? " " : "container"}>
        <>
          {article?.image && (
            <>
              {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
              <img
                src={article?.image?.url}
                alt={article?.image?.alt}
                className="img-fluid"
              />
              {article?.image?.caption && (
                <figcaption className="text-right text-muted mt-2">
                  <i
                    dangerouslySetInnerHTML={renderElement(
                      article?.image?.caption
                    )}
                  ></i>
                </figcaption>
              )}
            </>
          )}
          {article.video && (
            <>
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video controls autoPlay width="100%">
                <source src={article?.video?.url} type="video/mp4" />
              </video>
            </>
          )}
        </>
      </div>
    </section>
  )
}

export default SingleImageVideo
